/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { cloneDeep } from 'lodash';

// Components
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import IdPicker from 'shared/ui/components/form-components/pickers/IdPicker.vue';
import TargetingControl from 'shared/ui/components/form-components/TargetingControl.vue';

const __vue_script__ = {
    name: 'BadgeDesignPicker',

    components: { IdPicker, TargetingControl },

    extends: BaseControl,

    props: {
        value: {
            type: Object,
            required: true
        },

        event: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            innerValue: {}
        };
    },

    watch: {
        value: {
            immediate: true,
            deep: true,
            handler() {
                this.innerValue = cloneDeep(this.value);
            }
        }
    },

    methods: {
        emit() {
            this.$emit('change', this.innerValue);
        },

        delete() {
            this.$emit('remove');
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "badge-design-picker" },
    [
      _vm._t("top-header"),
      _c(
        "div",
        { staticClass: "config" },
        [
          _c("validation-provider", {
            attrs: {
              rules: "required",
              slim: true,
              name: _vm.name + "_design_id",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var errors = ref.errors
                  return [
                    _c("id-picker", {
                      attrs: {
                        "fp-type": "badge_design",
                        label: _vm.$t(
                          "onsite_scanning.settings.printer.badge_design"
                        ),
                        "event-id": _vm.event._id,
                        placeholder: _vm.$t(
                          "onsite_scanning.settings.printer.pick_design"
                        ),
                        name: _vm.name + "_design_id",
                        errors: errors,
                        sortable: false,
                      },
                      on: { input: _vm.emit },
                      model: {
                        value: _vm.innerValue.design_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.innerValue, "design_id", $$v)
                        },
                        expression: "innerValue.design_id",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm.innerValue.targetable
            ? _c("validation-provider", {
                attrs: {
                  rules: "required",
                  slim: true,
                  name: _vm.name + "_targeting",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var errors = ref.errors
                        return [
                          _c("targeting-control", {
                            ref: "targeting",
                            attrs: {
                              name: _vm.name + "_targeting",
                              expandable: false,
                              errors: errors,
                              "visible-to-label": _vm.$t(
                                "onsite_scanning.settings.printer.visible_label"
                              ),
                              "visible-to-desc": _vm.$t(
                                "onsite_scanning.settings.printer.visible_desc"
                              ),
                              "hidden-to-label": _vm.$t(
                                "onsite_scanning.settings.printer.not_visible_label"
                              ),
                              "hidden-to-desc": _vm.$t(
                                "onsite_scanning.settings.printer.not_visible_desc"
                              ),
                              "event-id": _vm.event._id,
                            },
                            on: { input: _vm.emit },
                            model: {
                              value: _vm.innerValue.targeting,
                              callback: function ($$v) {
                                _vm.$set(_vm.innerValue, "targeting", $$v)
                              },
                              expression: "innerValue.targeting",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2753566830
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/printing/BadgeDesignPicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__